import {
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  Typography,
} from "@material-ui/core";
import Link from "next/link";
import { withDefaultLayout } from "../src/layout/layout";

export default withDefaultLayout(function MyErrorPage({
  title,
  statusCode,
}: {
  title?: React.ReactNode;
  statusCode?: number;
}) {
  const code = statusCode ?? 404;

  return (
    <Container maxWidth="sm" disableGutters>
      <Card>
        <CardContent>
          <Typography variant="h4">{statusCode ?? 404}</Typography>
          <Typography>
            {title ??
              (code === 404
                ? "Seite konnte nicht gefunden werden"
                : code === 400
                ? "Fehlerhafte Eingabe"
                : code === 403
                ? "Der Zugriff auf diese Seite ist nicht erlaubt"
                : "Es ist ein Fehler aufgetreten")}
            .
          </Typography>
        </CardContent>
        <CardActions>
          <Link href="/" passHref>
            <Button color="primary" component="a">
              zurück zur Startseite
            </Button>
          </Link>
        </CardActions>
      </Card>
    </Container>
  );
});
